import React, { useState } from "react";
import DialogTestStart from '../DialogTestStart';
import DialogTopicTestDetails from '../DialogTopicTestDetails';
import CircularProgress from '@mui/material/CircularProgress';
// Styles
import styles from "./BottomDrawerTopicTest.module.css";

// MUI Components
import { Box, Link } from "@mui/material";

const BottomDrawer = (props) => {
  // States
  const [isExpanded, setIsExpanded] = useState(false);
  const childRef = React.useRef();
  const childRefStartTest = React.useRef();
  const [testDetail, setTestDetail] = React.useState({});


  // Utility Function
  // Function to toggle the bottom nav
  const setBottomNavStatus = () => {
    setIsExpanded(!isExpanded);
  };

  function showDetails(obj){
    props.selectedTestDetails(obj);
		setTestDetail(obj);
		childRef.current.handleClickOpen();		
	}
  function startMyTest(){
    props.startMyTest();
  }
  function continueCurrentTest(){
    props.continueCurrentTest();
  }
  function deleteCurrentStartNew(){
    props.deleteCurrentStartNew();
  }

  return (
    <div className={styles.bottom_drawer}>
      {/* Condition to check if the bottom nav is expanded or not */}
      {!isExpanded ? ( // Minimized view
        <div onClick={setBottomNavStatus} className={styles.bottom_min_mode}>
          {/* Arrow Animation */}
          <div className={styles.bottom_arrow}>
            <img
              src={process.env.PUBLIC_URL+"/arrow-up.svg"}
              className={styles.bottom_arrow_svg}
              alt="ETL arrow"
            />
          </div>

          {/* Text Content */}
          <div className={styles.bottom_main_content}>
            <p>{props.searchQuery}</p>
            {(props.topicTestList!=null && props.topicTestList.length>0)?
              <>Click to expand to get topic-test list</>:
              <span style={{fontSize:12,color:'#FF0000',fontWeight:'bold'}} >
                No topic test found
              </span>}
          </div>


        </div>
      ) : (
        // Expanded View
        <div className={styles.bottom_expanded}>
          {/* Down Arrow */}
          <div
            onClick={() => {
              setIsExpanded(false);
            }}
            className={styles.bottom_arrow_down}
          >
            <img
              src={process.env.PUBLIC_URL+"/arrow-up.svg"}
              className={styles.bottom_arrow_svg_down}
              alt="ETL arrow"
            />
          </div>
          {/* Main Text Content */}
          <div className={styles.bottom_main_content}>
            <p>{props.searchQuery}</p>

              <Box mt={1}>
                    {props.showProgress?<CircularProgress style={{width:20,height:20}} />:null}
                    {(props.topicTestList!=null && props.topicTestList.length>0)?<>
                    <b>Click below links to start topic test</b>								
                    <Box>
                        <ul style={{marginLeft:-50}}>
                          {
                            (props.topicTestList!=null && props.topicTestList.length>0)?props.topicTestList.map((myRow,indextt)=>(
                              <li key={'intt'+indextt}><Link onClick={()=>{showDetails(myRow)}} style={{cursor:'pointer', fontWeight:'bold',fontSize:13, textDecoration:'none'}} >{myRow.mockTestTitle}</Link></li>
                            )):null
                          }	
                        </ul>
                    </Box>
                    </>
                    :props.searchQuery?<span style={{fontSize:12,color:'#FF0000',fontWeight:'bold'}}>
                    No topic test found
                    </span>
                  :null}
							</Box>

          </div>

          <DialogTopicTestDetails toCallStartTest={startMyTest} testDetail={testDetail} ref={childRef} />
      		<DialogTestStart deleteCurrentStartNew={deleteCurrentStartNew} continueCurrentTest={continueCurrentTest} currentRunningTestTitle={props.currentRunningTestTitle} ref={childRefStartTest}  />							 


        </div>
      )}
    </div>
  );
};

export default BottomDrawer;
